import { Box, Button, Card, CardActions, CardContent, Typography } from "@mui/material";
import GuestsIcon from 'src/assets/icons/booking/GuestsIcon';
import LengthIcon from 'src/assets/icons/booking/LengthIcon';
import { LocationIcon } from "src/assets/icons/LocationIcon";
import { ClockIcon } from "src/assets/icons/ClockIcon";
import DateIcon from "src/assets/icons/DateIcon";
import { useTranslation } from "react-i18next";
import Iconify from "../iconify";
import { formatMinutesToHours } from "src/utils/reservationFunctions";
import { isToday, isTomorrow } from "src/utils/dateUtils";

const ReservationDetailsCard = ({ formData, handleModify }) => {
    const {t} = useTranslation();

    return (
        <Card sx={{position: 'absolute', top: 30, left: '50%', transform: 'translateX(-50%)', zIndex: 11}}>
            <CardContent sx={{pb: 0}}>
                <Box sx={{ display: 'flex', gap: 8 }}>
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <GuestsIcon />
                            <Typography variant="body1">{formData.guests}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <DateIcon />
                            <Typography variant="body1">
                                {
                                    isToday(new Date(formData.date)) 
                                        ? t('bookings.today') 
                                        : isTomorrow(new Date(formData.date)) 
                                            ? t('bookings.tomorrow') 
                                            : formData.date
                                }
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <ClockIcon />
                            <Typography variant="body1">{formData.time}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <LocationIcon />
                            <Typography variant="body1">{formData.area}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <LengthIcon />
                            <Typography variant="body1">{formatMinutesToHours(formData.length)}</Typography>
                        </Box>
                    </Box>
                </Box>
            </CardContent>
            <CardActions sx={{display: 'flex', justifyContent: 'center'}}>
                <Button
                    onClick={handleModify}
                    sx={{
                        color: "white",
                    }}
                >
                    <Iconify icon="material-symbols:chevron-left" width={24} sx={{ transform: 'rotate(-90deg)' }}  />
                    {t('bookings.modify')}
                </Button>
            </CardActions>
        </Card>
    )
}

export default ReservationDetailsCard;